var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.375793C5.8724 0.375793 0.5 5.74819 0.5 12.3758C0.5 19.0034 5.8724 24.3758 12.5 24.3758C19.1276 24.3758 24.5 19.0034 24.5 12.3758C24.5 5.74819 19.1276 0.375793 12.5 0.375793Z",
    fill: "url(#paint0_linear_102_240)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2285 17.2336H17.4851L17.9966 13.9254H14.2285V12.1172C14.2285 10.7431 14.6778 9.52441 15.9632 9.52441H18.0287V6.63778C17.6657 6.58871 16.8981 6.48175 15.4479 6.48175C12.4191 6.48175 10.6435 8.0811 10.6435 11.7252V13.9261H7.52979V17.2342H10.6429V26.327C11.2595 26.4188 11.8843 26.4818 12.5254 26.4818C13.1048 26.4818 13.6705 26.4289 14.2285 26.3534V17.2336Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_102_240",
    x1: 4.0958,
    y1: 3.97159,
    x2: 22.469,
    y2: 22.3448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AA4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AD9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.375793)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e472d56b7b27c83f3986a38d73f656ff.svg";
export { ForwardRef as ReactComponent };